import axios from "axios";

const BASE = "/admin/platform-email";

export const fetchPlatformEmailSettings = () => axios.get(`${BASE}/settings`);
export const savePlatformEmailSettings = (payload) => axios.put(`${BASE}/settings`, payload);
export const testPlatformEmailConnection = () => axios.post(`${BASE}/settings/test-connection`);
export const sendPlatformEmailTest = (to) => axios.post(`${BASE}/settings/test-email`, { to });

export const fetchPlatformEmailTemplates = () => axios.get(`${BASE}/templates`);
export const previewPlatformEmailTemplate = (payload) => axios.post(`${BASE}/templates/preview`, payload);
export const savePlatformEmailTemplateDraft = ({ templateKey, locale, ...payload }) =>
  axios.post(
    `${BASE}/templates/${encodeURIComponent(templateKey)}/${encodeURIComponent(locale)}/versions`,
    payload
  );
export const activatePlatformEmailTemplateVersion = ({ templateKey, locale, version }) =>
  axios.post(
    `${BASE}/templates/${encodeURIComponent(templateKey)}/${encodeURIComponent(locale)}/versions/${version}/activate`
  );
